import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from 'mailup-web-components'

import {
  modalSubscribeCanConfirmState,
  modalSubscribeHasEmailChannel,
  modalSubscribeShowChannelsState,
  modalSubscribeState,
} from 'Pages/RecipientsList/recoil/state/modalSubscribe'

import {
  modalSubscribeCancelCallback,
  modalSubscribeConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalSubscribe'

import Divider from 'Components/Divider'
import RenderWhen from 'Components/RenderWhen'
import InputChannels from 'Pages/RecipientsList/components/modals/subscribe/InputChannels'
import InputConfirmation from 'Pages/RecipientsList/components/modals/subscribe/InputConfirmation'
import InputForceSubscription from 'Pages/RecipientsList/components/modals/subscribe/InputForceSubscription'
import InputLists from 'Pages/RecipientsList/components/modals/subscribe/InputLists'

const ModalSubscribe: FC = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalSubscribeState)

  const hasEmailChannel = useRecoilValue(modalSubscribeHasEmailChannel)

  const showChannels = useRecoilValue(modalSubscribeShowChannelsState)

  const canConfirm = useRecoilValue(modalSubscribeCanConfirmState)

  const handleCancel = useRecoilCallback(modalSubscribeCancelCallback, [])
  const handleConfirm = useRecoilCallback(modalSubscribeConfirmCallback, [])

  return (
    <Modal
      show={show}
      onClose={handleCancel}
      data-mu-test="modal-subscribe"
      closeOnOverlayClick
      showClose
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.RecipientsList.ModalSubscribeTitle',
        })}
      />

      <ModalBody>
        <Flex flexDirection="column" gap="24px">
          <InputLists />

          <RenderWhen condition={showChannels}>
            <InputChannels />
          </RenderWhen>

          <RenderWhen condition={hasEmailChannel}>
            <Divider margin="0" />
            <InputConfirmation />
            <Divider margin="0" />
          </RenderWhen>

          <InputForceSubscription />
        </Flex>
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="confirm"
          onClick={handleConfirm}
          disabled={!canConfirm}
        >
          {intl.formatMessage({
            id: 'Load.RecipientsList.ModalSubscribeConfirm',
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSubscribe
